import React, { useState, useEffect } from "react";
import NavBar from "../../components/general/NavBarApp";
import KeyMetricsSection from "../../components/synthese-financiere/KeyMetricsSection"; // Tu créeras ce fichier
import ChartsSection from "../../components/synthese-financiere/ChartsSection"; // Tu créeras ce fichier
import RecentInvoicesSection from "../../components/synthese-financiere/RecentInvoicesSection"; // Tu créeras ce fichier
import "../../assets/css/synthese-financiere.css";
import download from "../../assets/img/ico/download.svg";
import DateRangePicker from "../../components/general/DateRangePicker";
import NavBarApp from "../../components/general/NavBarApp";

function SyntheseFinancierePage() {
  // Ici, tu peux gérer l'état pour la période sélectionnée,
  // les données financières, etc.
  const [selectedPeriod, setSelectedPeriod] = useState("Ce mois");
  const [financialData, setFinancialData] = useState(null);
  // Ajoute l'état pour la plage de dates
  const [selectedDateRange, setSelectedDateRange] = useState(
    "Sam.01 mars.25 - Dim.02 mars.25"
  );
  // Exemple d'appel de données (à adapter à ton API)
  useEffect(() => {
    // Simuler un appel API
    const fetchData = async () => {
      // Ici, tu ferais un appel à ton backend pour récupérer les données financières
      // const response = await fetch('/api/financial-data?period=' + selectedPeriod);
      // const data = await response.json();
      // setFinancialData(data);

      // Données fictives pour l'exemple
      const dummyData = {
        // Données pour KeyMetricsSection
        keyMetrics: {
          last90Days: "5 600 €",
          totalPaidTransactions: "85 600 €",
          pendingInvoices: "16 200 €",
          overdueInvoices: "2 800 €",
        },

        // Données pour ChartsSection - Graphique de flux de trésorerie (format Chart.js)
        cashFlowData: {
          labels: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil"], // Plus de points pour un graphique plus long
          datasets: [
            {
              label: "Paiements reçus",
              data: [1500, 1700, 1900, 1800, 2000, 2200, 2300],
              borderColor: "#66c2a5",
              backgroundColor: "rgba(102, 194, 165, 0.2)",
              tension: 0.4,
              fill: false,
              pointBackgroundColor: "#66c2a5",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "#66c2a5",
            },
            {
              label: "Paiements en attente",
              data: [700, 650, 600, 750, 700, 800, 780],
              borderColor: "#fc8d62",
              backgroundColor: "rgba(252, 141, 98, 0.2)",
              tension: 0.4,
              fill: false,
              pointBackgroundColor: "#fc8d62",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "#fc8d62",
            },
            {
              label: "Paiements en retard",
              data: [150, 100, 120, 110, 130, 100, 90],
              borderColor: "#8da0cb",
              backgroundColor: "rgba(141, 160, 203, 0.2)",
              tension: 0.4,
              fill: false,
              pointBackgroundColor: "#8da0cb",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "#8da0cb",
            },
          ],
        },

        // Données pour ChartsSection - Graphiques en secteurs (% CA par client - format Chart.js)
        // Ici, je vais donner un exemple pour un seul Pie Chart global
        salesDistributionData: {
          labels: [
            "Client Alpha",
            "Client Beta",
            "Client Gamma",
            "Client Delta",
            "Autres Clients",
          ],
          datasets: [
            {
              data: [25000, 18000, 12000, 9000, 36000], // Montants de CA par client
              backgroundColor: [
                "#a6cee3",
                "#1f78b4",
                "#b2df8a",
                "#33a02c",
                "#fb9a99",
                "#e31a1c",
                "#fdbf6f",
                "#ff7f00",
                "#cab2d6",
                "#6a3d9a",
              ],
              borderColor: "#fff",
              borderWidth: 2,
            },
          ],
        },

        // Données pour RecentInvoicesSection
        recentInvoices: [
          {
            id: 1,
            number: "#12345",
            client: "SAS Hotel Fontaine",
            issueDate: "02/01/25", // Format texte pour cet exemple
            amount: 2360.5, // Utilise un nombre pour le formatage
            status: "Payée",
          },
          {
            id: 2,
            number: "#12346",
            client: "SARL Dupuis & Fils",
            issueDate: "02/01/25",
            amount: 1500.0,
            status: "En attente",
          },
          {
            id: 3,
            number: "#12347",
            client: "EURL Bernard",
            issueDate: "03/01/25",
            amount: 850.75,
            status: "Payée",
          },
          {
            id: 4,
            number: "#12348",
            client: "SAS Hotel Fontaine",
            issueDate: "03/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 5,
            number: "#12349",
            client: "Client Test",
            issueDate: "04/01/25",
            amount: 500.0,
            status: "En retard", // Ajout d'un statut "En retard"
          },
          {
            id: 6,
            number: "#12350",
            client: "SARL Dupuis & Fils",
            issueDate: "04/01/25",
            amount: 1500.0,
            status: "En attente",
          },
          {
            id: 7,
            number: "#12351",
            client: "EURL Bernard",
            issueDate: "05/01/25",
            amount: 850.75,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
          {
            id: 8,
            number: "#12352",
            client: "SAS Hotel Fontaine",
            issueDate: "05/01/25",
            amount: 2360.5,
            status: "Payée",
          },
        ],
      };
      setFinancialData(dummyData);
    };

    fetchData();
  }, [selectedPeriod]); // Recharger les données si la période change

  const [selected, setSelected] = useState("Ce mois");
  const [open, setOpen] = useState(false);

  const options = ["90 derniers jours", "6 derniers mois", "Ce mois"];

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
    // ici tu pourrais trier ton tableau offer selon la valeur choisie
  };

  return (
    <section className="financial-dashboard-section" id="financial">
      <NavBarApp userType="entreprise" />
      <div className="financial-dashboard-container">
        <div className="financial-header">
          <div className="header-title">
            <h3>Synthèse Financière</h3>{" "}
            {/* Utilise H1 ou H2 selon la structure globale */}
          </div>

          <div className="header-controls">
            <div className="filter-group">
              <label htmlFor="period-select" className="filter-label">
                Trier par
              </label>

              <div className="custom-dropdown" onClick={() => setOpen(!open)}>
                <button className="custom-dropdown-button">
                  {selected}
                  <i
                    className={`fa-solid fa-chevron-down ${
                      open ? "rotate" : ""
                    }`}
                  ></i>
                </button>

                {open && (
                  <ul className="custom-dropdown-menu">
                    {options.map((option) => (
                      <li
                        key={option}
                        onClick={() => handleSelect(option)}
                        className={`custom-dropdown-item ${
                          selected === option ? "active" : ""
                        }`}
                      >
                        {option}
                        {selected === option && (
                          <i className="fa-solid fa-check check-icon"></i>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="filter-group">
              <DateRangePicker />
            </div>

            <button className="btn icon">
              {/* Icône de téléchargement ici, par exemple <FiDownload /> */}
              <span className="icon-wrapper">
                <img src={download} alt="Icône de téléchargement"></img>{" "}
                {/* Ajout de l'attribut alt pour l'accessibilité */}
              </span>{" "}
              Télécharger le rapport
              {/* Une petite icône ou image à droite du texte, comme sur le design */}
            </button>
          </div>
        </div>

        {financialData ? (
          <>
            <KeyMetricsSection metrics={financialData.keyMetrics} />
            <ChartsSection
              cashFlowData={financialData.cashFlowData}
              salesDistributionData={financialData.salesDistributionData}
            />
            <RecentInvoicesSection invoices={financialData.recentInvoices} />
          </>
        ) : (
          <div>Chargement des données...</div> // Indicateur de chargement
        )}
      </div>
    </section>
  );
}

export default SyntheseFinancierePage;
